import React from 'react'

const OfferStoriesStrip = ({ stories = [], onStoryOpen }) => {
  if (!stories || stories.length === 0) {
    return null
  }

  return (
    <div className="mb-8">
      <style>{`
        .offer-stories-scroll::-webkit-scrollbar {
          display: none;
        }
        .offer-stories-scroll {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
      <div className="flex items-center gap-2 mb-3">
        <h2 className="text-lg font-bold text-slate-900">New Offers</h2>
        <span className="text-xs text-slate-500">(24h)</span>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-2 -mx-4 px-4 offer-stories-scroll">
        {stories.map((story, index) => {
          const imageUrl = story.images && story.images.length > 0 ? story.images[0] : null
          const title = story.title || 'Untitled Offer'
          const centerName = story.centerId?.organization || 'Unknown Center'
          
          return (
            <button
              key={story._id || story.id || index}
              onClick={() => onStoryOpen && onStoryOpen(index)}
              className="flex-shrink-0 flex flex-col items-center gap-2 group cursor-pointer"
            >
              {/* Story Circle */}
              <div className="relative">
                <div className="w-20 h-20 rounded-full overflow-hidden bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 p-0.5 group-hover:scale-105 transition-transform">
                  <div className="w-full h-full rounded-full overflow-hidden bg-white">
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt={title}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-cyan-50 to-blue-50">
                        <svg className="w-8 h-8 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              {/* Title */}
              <div className="text-center max-w-[80px]">
                <p className="text-xs font-medium text-slate-900 line-clamp-2 group-hover:text-cyan-700 transition-colors">
                  {title}
                </p>
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default OfferStoriesStrip
